import goto from ".";

export default {
  exitDynamicSurvey() {
    if (!goto.nativeWebviewExit()) {
      goto.landing();
    }
  },
};
